module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Fc-Gd-Hc-Ia-inside.d054c1f5.png";